<template>
  <div class="slider-container" ref="sliderContainer">
    <div class="slider" ref="slider" @click="click">
      <div class="bar" ref="bar" :style="{
          'width': left + '%'
        }"></div>
      <span class="circle" :class="{'no-data': valueLabel == 0}" ref="circle"
        :style="{
          'left': left + '%'
        }"
        @mousedown="mousedown"
      ></span>
    </div>
    <span class="slider-number">{{ label ? valueLabel : ''}}
      <slot></slot>
    </span>
  </div>
</template>

<script>

export default {
  name: 'slider',
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    defaultValue: {
      type: Number,
      default: 100
    },
    reset: {
      type: Boolean,
      default: false
    },
    label: {
      type: Boolean,
      default: true
    },
  },
  watch: {
    reset () {
      this.init()
    },
    defaultValue (val, oldVal) {
      if (val !== oldVal ) {
        this.init()
      }
    }
  },
  data() {
    return {
      left: 100,
      changeFlag: false,
      outerLeft: 0,
      width: 0,
      valueLabel: 100
    }
  },
  created() {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.left = this.defaultValue * 100 / this.max
      this.valueLabel = this.defaultValue
      if (this.min) {
        if (this.min !== this.defaultValue) {
          this.left = (this.defaultValue - this.min)/(this.max - this.min) * 100
        } else {
          this.left = 0
        }
      }
      if (this.step) {
        this.valueLabel = (this.defaultValue/this.step).toFixed(String(this.step).length - 1)
      }
    },
    move(e) {
      if (!this.changeFlag) {
        return
      }
      const pos = this.getMousePos(e)
      this.left = pos.value
      this.valueLabel = pos.valueLabel
      this.$emit('getValue', pos.valueLabel)
    },
    mousedown() {
      this.changeFlag = true
      window.addEventListener('mousemove', this.move);
      window.addEventListener('mouseup', this.onDragEnd);
    },
    onDragEnd () {
      setTimeout(() => {
        this.changeFlag = false
        this.$nextTick(() => {
          this.$emit('changed', this.valueLabel)
        })
      }, 0);
      window.removeEventListener('mousemove', this.move);
      window.removeEventListener('mouseup', this.onDragEnd);
    },
    getLeft () {
      const elementLeft = (e) => { //计算x坐标
      var offset = e.offsetLeft;
      if(e.offsetParent != null) offset += elementLeft(e.offsetParent);
        return offset;
      }
      const left = elementLeft(this.$refs.slider)
      return left
    },
    click(e) {
      const pos = this.getMousePos(e)
      this.left = pos.value
      this.valueLabel = pos.valueLabel
      this.$emit('click', pos.valueLabel)
    },
    getMousePos(event) {
      var e = event || window.event;
      var scrollX = document.documentElement.scrollLeft || document.body.scrollLeft;
      var x = e.pageX || e.clientX + scrollX;
      let value = parseInt((x - this.getLeft()) / this.$refs.slider.offsetWidth * 100)
      if (value > 100 ) {
        value = 100
      } 
      if (value < 0) {
        value = 0
      }
      let valueLabel = this.min + Math.round(value / (100/ (this.max - this.min)))
      if (this.step) {
        valueLabel = (valueLabel/this.step).toFixed(String(this.step).length - 1)
      }
      return {value, valueLabel }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.slider-container {
  display: flex;
  align-items: center;
  touch-action: none;
  .slider {
    position: relative;
    background: #E0E0E0;
    height: 4px;
    border-radius: 2px;
    flex: 1;
    cursor: pointer;
    .bar {
      position: absolute;
      background: #4E6EFF;
      width: 50%;
      height: 4px;
      border-radius: 2px;
      left: 0;
      top: 0;
    }
    .circle {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 10px;
      height: 10px;
      background: #4E6EFF;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
      transform: translate(-50%, -50%);
      border-radius: 5px;
      &.no-data {
        background: #fff;
        box-shadow: 0px 0px 4px 0px #777777;
      }
    }
  }
  .slider-number {
    margin-left: 10px;
  }
}
</style>
